import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import { Link } from "react-router-dom";

export default function Home() {
  const pageRef = useRef(null);
  const contentRef1 = useRef(null);
  const homeContainerRef1 = useRef(null);
  const contentRef2 = useRef(null);
  const homeContainerRef2 = useRef(null);
  const contentRef3 = useRef(null);

  useEffect(() => {
    anime({
      targets: pageRef.current,
      opacity: [0, 1],
      translateY: [50, 0],
      duration: 3000,
      easing: "easeOutExpo",
    });
    anime({
      targets: [contentRef1.current, contentRef2.current, contentRef3.current],
      opacity: [0, 1],
      translateY: [30, 0],
      duration: 2000,
      easing: "easeOutExpo",
      delay: anime.stagger(300, { start: 500 }),
    });
    anime({
      targets: [homeContainerRef1.current, homeContainerRef2.current],
      opacity: [0, 1],
      translateY: [30, 0],
      duration: 2000,
      easing: "easeOutExpo",
      delay: anime.stagger(300, { start: 1000 }),
    });
  }, []);

  return (
    <div className="container">
      <div className="home-page" ref={pageRef}>
        <div className="home-page-row">
          <img alt="maskot" src="/maskot.png" className="sckoro-img" />
          <div>
            <h1 className="home-text">ЛУЧШИЙ ПРОЕКТ 2025 ГОДА!</h1>
            <p>Raytolfas — это будущее технологий, созданное с душой!</p>
            <Link to="/about" className="button-submit">
              <span>Узнать больше</span>
              <svg className="icon-submit" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      <div className="content-container" ref={contentRef1}>
        <div className="home-page-row">
          <img alt="banner" src="/raytolfas-banner.jpg" className="sckoro-img" />
          <div>
            <h1 className="home-text">ХОЧЕШЬ СТАТЬ ЧАСТЬЮ RAYTOLFAS?</h1>
            <p>
              Raytolfas объединяет технологии и креативность для создания
              уникальных решений, меняющих мир.
            </p>
            <Link
              to="https://docs.google.com/forms/d/e/1FAIpQLSc3M-YS9T8jWB3HY0xTzC-5dHZsUniDUM2VNbfyKZo1DCwOSg/viewform?usp=header"
              className="button-submit"
            >
              <span>Написать нам</span>
              <svg className="icon-submit" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      <div className="home-container" ref={homeContainerRef1}>
        <div className="home-page-row">
          <img alt="tech" src="/logo.png" className="img-contents" />
          <div>
            <h2 className="home-text">Почему выбирают Raytolfas?</h2>
            <ul>
              <li>Передовые технологии для будущего</li>
              <li>Команда профессионалов и энтузиастов</li>
              <li>Открытость к новым идеям и талантам</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="content-container" ref={contentRef2}>
        <div className="home-page-row">
          <img alt="mission" src="/raytolfas-banner.jpg" className="sckoro-img" />
          <div>
            <h2 className="home-text">Наша миссия</h2>
            <p>
              Мы в Raytolfas переосмысливаем технологии, чтобы сделать жизнь
              лучше, создавая устойчивые и доступные решения.
            </p>
            <Link to="/about" className="Link-button">
              Подробнее о нас
            </Link>
          </div>
        </div>
      </div>

      <div className="home-container" ref={homeContainerRef2}>
        <div className="home-page-row">
          <h2 className="home-text">Наша команда</h2>
          <div className="home-page-row">
            <div>
              <img alt="team-member1" src="/mixitosik.png" className="profile" />
              <p>MIXITOSIK — Основатель проекта</p>
            </div>
            <div>
              <img alt="team-member2" src="/gradient1.png" className="profile" />
              <p>(Скоро) — Главный разработчик</p>
            </div>
            <div>
              <img alt="team-member3" src="/gradient1.png" className="profile" />
              <p>(Скоро) — Дизайнер</p>
            </div>
          </div>
        </div>
      </div>

      <div className="content-container" ref={contentRef3}>
        <h2 className="home-text">Готовы к переменам?</h2>
        <p>Присоединяйтесь к Raytolfas и создавайте будущее вместе с нами!</p>
        <Link
          to="https://docs.google.com/forms/d/e/1FAIpQLSc3M-YS9T8jWB3HY0xTzC-5dHZsUniDUM2VNbfyKZo1DCwOSg/viewform?usp=header"
          className="button-submit"
        >
          <span>Стать частью команды</span>
          <svg className="icon-submit" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </div>
  );
}